import { render, staticRenderFns } from "./LandingPassengersDataForm.vue?vue&type=template&id=00a55712&"
import script from "./LandingPassengersDataForm.vue?vue&type=script&lang=js&"
export * from "./LandingPassengersDataForm.vue?vue&type=script&lang=js&"
import style0 from "./LandingPassengersDataForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a55712')) {
      api.createRecord('00a55712', component.options)
    } else {
      api.reload('00a55712', component.options)
    }
    module.hot.accept("./LandingPassengersDataForm.vue?vue&type=template&id=00a55712&", function () {
      api.rerender('00a55712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/dialog/data/LandingPassengersDataForm.vue"
export default component.exports